module.exports = __webpack_public_path__ + "cd7a5a392960c408e0ac4e670d626b7d.pdf";